<template>
  <tr
    :class="{
      abnormalBg: driverAbnormalState,
    }"
    class="bill-row fontSize16 text_hailing dropdown"
    @click="setDriverInfo"
  >
    <td class="word_center order-id-click" @click="$emit('open-modal')">
      {{ bill.orderId ? bill.orderId : '' }}
      ({{ bill.driverConfirmOrderStatus }})
    </td>
    <td
      class="word_center"
      :class="{ driverCallNum: bill.orderNote }"
      width="50px"
    >
      <el-tooltip v-if="bill.orderNote !== ''" placement="top">
        <div slot="content">
          {{ bill.orderNote }}
        </div>
        <span>
          {{
            bill.driverCallNumber === '----'
              ? bill.teamName
              : bill.driverCallNumber
          }}
        </span>
      </el-tooltip>
      <span v-else>
        {{
          bill.driverCallNumber === '----'
            ? bill.teamName
            : bill.driverCallNumber
        }}
      </span>
    </td>
    <td class="word_center" width="140px">
      <!-- <div class="row" v-if="bill.orderStatus !== '未有司機接單' && '詢車中'">
        {{ bill.driverGrabOrderDate }}
        {{ estimatedTime ? '(' + estimatedTime + '分)' : '' }}
      </div> -->
      <div
        class="row"
        v-if="bill.driverId && bill.driverConfirmOrderStatus !== '無找到車'"
      >
        {{ bill.driverGrabOrderDate }}
        {{ estimatedTime ? '(' + estimatedTime + '分)' : '' }}
      </div>
      <div class="row" v-else>無司機接單</div>
      <div class="row" style="color: #ff2d2d" v-if="passengerTime">
        {{ passengerTime }}
      </div>
    </td>
    <td class="word_center" width="360px">
      {{ bill.passengerPhoneNumber }}/
      <span style="color: #0047ba; font-weight: 900">
        {{ bill.onLocation }}
      </span>
      /{{ bill.passengerNote }}
    </td>
    <td class="word_center">
      <!--若有取消原因則在hover時顯示-->
      <el-tooltip v-if="bill.cancelReason !== ''" placement="top">
        <div slot="content" style="font-size: 1.8rem">
          {{ bill.cancelReason }}
        </div>
        <span class="cancel-reason">{{ bill.orderStatus }}</span>
      </el-tooltip>
      <span v-else>
        {{ bill.orderStatus }}
      </span>
    </td>
    <td class="word_center" width="120px">
      <div class="row">
        {{ bill.passengerName }}
      </div>
      <div class="row word_centers" v-for="msg in bill.messageData">
        {{ msg }}
      </div>
    </td>
    <td class="word_center">
      <el-checkbox
        v-if="driverAbnormalState"
        v-model="isAbnormalCheck"
        @change="onCheck"
        class="abnormal-checkbox"
      />
    </td>
    <td width="100px">
      <div class="row word_center">
        {{ bill.orderCreatedDate }}
      </div>
    </td>
  </tr>
</template>

<script>
import {
  reqDriverAbnormal,
  reqUpdateAbnormalMsg,
  reqAbnormalSolve,
  reqDriverInfo,
  reqDriverStatus,
} from '@/api/hailState-v2'
import dayjs from 'dayjs'
import { mapState, mapMutations, mapActions } from 'vuex'
import { speakInBrowser, sendNotify } from '@/utils/helper'

export default {
  props: {
    bill: Object,
  },
  data() {
    return {
      abnormalId: '',
      isAbnormalCheck: false,
      messageHistory: [],
      checkCount: 0,
      playedMessages: {},
    }
  },
  methods: {
    ...mapActions('hailStateV2', {
      vx_fetchBillList: 'fetchBillList',
      vx_fetchReserveListCount: 'fetchReserveListCount',
    }),
    ...mapMutations('hailStateV2', {
      vx_setDriverInfo: 'setDriverInfo',
    }),
    async setDriverInfo() {
      try {
        const { result } = await reqDriverInfo(this.bill.orderId)
        // 將司機資訊放到vuex
        this.vx_setDriverInfo(result)
      } catch (e) {
        console.error(e)
      }
    },
    async updateAbnormal(isSolve) {
      try {
        if (isSolve) {
          await reqAbnormalSolve(this.abnormalId)
        } else {
          await reqUpdateAbnormalMsg(this.abnormalId)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async onCheck() {
      if (this.abnormalId === '' || !this.isAbnormalCheck) return
      // 若是重複勾選4次，將會取消訂單的異常狀態
      this.checkCount += 1
      try {
        console.log('count', this.checkCount)
        if (this.checkCount === 4) {
          // 更新異常狀態
          await reqDriverAbnormal(this.abnormalId)
          // 更新table訂單資料
          await this.vx_fetchBillList()
          await this.vx_fetchReserveListCount()
          this.checkCount = 0
        }
      } catch (e) {
        console.error(e)
      } finally {
        // 300ms後將勾選取消
        setTimeout(() => (this.isAbnormalCheck = false), 300)
      }
    },
    // 訂單異常提醒
    abnormalNotify(onLocationStr) {
      console.log('異常提醒')
      sendNotify({
        title: `訂單出現異常`,
        body: `${onLocationStr}`,
      })
      if (this.vx_switchSpeech) {
        speakInBrowser('訂單出現異常')
      }
    },
    // 司機訊息提醒
    msgNotify(onLocationStr) {
      console.log('訊息提醒')
      sendNotify({
        title: `訂單出現異常`,
        body: `${onLocationStr}`,
      })
      if (this.vx_switchSpeech) {
        this.bill.messageData.forEach((msg) => {
          if (!this.playedMessages[msg]) {
            speakInBrowser(msg)
            this.playedMessages[msg] = true
          }
        })
      }
    },
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_switchSpeech: 'switchSpeech',
    }),
    /* 檢測司機是否有移動 */
    driverAbnormalState() {
      const { orderStatus } = this.bill
      const abnormalState = JSON.parse(JSON.stringify(this.bill.abnormalState))
      /* orderStatus : 訂單異常, 詢車中, 未有司機接單, 司機已接單, 司機已載客, 乘客取消, 司機取消, 已完成 */
      if (
        orderStatus === '司機取消' ||
        orderStatus === '司機已載客' ||
        orderStatus === '乘客取消' ||
        orderStatus === '已完成'
      ) {
        return false
      }
      if (orderStatus !== '司機已接單') return false
      this.abnormalId = abnormalState.id
      if (
        this.messageHistory.length === 0 &&
        this.messageHistory.length < this.bill.messageData.length
      ) {
        /* 發異常、reset狀態 */
        this.messageHistory = this.bill.messageData
        return true
      }
      if (
        this.messageHistory.length !== 0 &&
        this.messageHistory.length < this.bill.messageData.length
      ) {
        /* 發異常、reset狀態 */
        this.messageHistory = this.bill.messageData
        this.msgNotify(this.bill.onLocation)
        this.updateAbnormal(false)
        /* this.updateAbnormalMessage() */
        return true
      }
      if (
        !abnormalState.driverIsMessageOrder &&
        abnormalState.remindCount >= 4
      ) {
        this.updateAbnormal(true)
        console.warn('remind count >= 4')
        /* this.updateAbnormalSolve() */
        return false
      }
      if (
        !abnormalState.driverIsMessageOrder &&
        this.messageHistory.length !== 0 &&
        this.bill.messageData.length !== 0
      ) {
        this.msgNotify(this.bill.onLocation)
        return true
      }
      const isStore = this.bill.orderNote.indexOf('商家叫車') >= 0
      if (Object.keys(abnormalState).length === 0 && !isStore) return false
      if (abnormalState.remindCount >= 4) return false
      /* 處理司機搶單成功，尚未點擊確認，應該要出現訂單異常 */
      if (!abnormalState.driverIsConfirmOrder) {
        this.abnormalNotify(this.bill.onLocation)
        return true
      }
      return false
    },
    estimatedTime() {
      /* 先判斷是不是後派單，若備註的結尾有後派單那它就是後派單 */
      const isDispatchOrder = this.bill.passengerNote.includes('後派單')
      // 後派單一率不顯示時間
      if (isDispatchOrder) {
        return null
      }
      // 如果有估計時間則返回，否則返回 null
      return this.bill.estimatedTime || null
    },
    passengerTime() {
      return this.bill.getPassengerTime
        ? dayjs(this.bill.getPassengerTime).format('YYYY-MM-DD HH:mm:ss')
        : null
    },
  },
}
</script>

<style scoped>
.bill-row.abnormalBg {
  background-color: #ff6868;
}

.order-id-click,
.driverCallNum {
  color: #3385ff;
  text-decoration: underline;
}

.order-id-click:hover,
.driverCallNum:hover {
  cursor: pointer;
  color: #0066ff;
  text-decoration: underline;
}

.cancel-reason:hover {
  cursor: pointer;
  color: #0066ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/BillRow.vue